/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CreateContactPersonV1Dto = {
  /**
   * The salutation of the contact-person.
   */
  salutation: CreateContactPersonV1Dto.salutation;
  /**
   * The title of the contact-person.
   */
  title?: CreateContactPersonV1Dto.title | null;
  /**
   * The first name of the contact-person.
   */
  firstName?: string | null;
  /**
   * The last name of the contact-person.
   */
  lastName: string;
  /**
   * The code of the contact-person. Default: first letter of first name, first letter of last name
   */
  code: string;
  /**
   * The phone number of the contact-person.
   */
  phone?: string | null;
  /**
   * The mobile number of the contact-person.
   */
  mobile?: string | null;
  /**
   * The eMail address of the contact-person.
   */
  eMail: string;
};
export namespace CreateContactPersonV1Dto {
  /**
   * The salutation of the contact-person.
   */
  export enum salutation {
    MR_ = 'Mr.',
    MRS_ = 'Mrs.',
    MS_ = 'Ms.',
  }
  /**
   * The title of the contact-person.
   */
  export enum title {
    PROF_ = 'Prof.',
    DR_ = 'Dr.',
    PROF_DR_ = 'Prof. Dr.',
  }
}
